import React from 'react';
import {Badge} from 'reactstrap';
import {Table, ButtonGroup, Button, UncontrolledTooltip} from "reactstrap";
import {getColourFromScore} from "./util";

class SextantPerio extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            PerioMode: 0
        };
    }

    componentWillMount() {

    }

    componentDidMount() {
        // fetch scorecard info
    }


    buttonsFromTooth(tooth) {
        let insideTerm = "Lingual";
        let outsideTerm = "Buccal";


        if ((tooth >= 6 && tooth <= 11) || (tooth >= 22 && tooth <= 27)) { // anterior tooth
            outsideTerm = "Facial";
        }

        if ((tooth >= 1 && tooth <= 16)) { // top
            insideTerm = "Palatal"
        }

        return (
            <ButtonGroup className="p-1">
                <Button className={this.state.PerioMode === 0 ? "tooth-button-on" : "tooth-button-off" } onClick={() => this.sideButtonClicked(0)} active={this.state.PerioMode === 0}>{insideTerm}</Button>
                <Button className={this.state.PerioMode === 1 ? "tooth-button-on" : "tooth-button-off" } onClick={() => this.sideButtonClicked(1)} active={this.state.PerioMode === 1}>{outsideTerm}</Button>
            </ButtonGroup>
        );
    }

    sideButtonClicked(side) {
        this.setState({
            PerioMode: side
        });
    }

    getValue(name, direction) {
        let sideKey;
        if (this.state.PerioMode === 0) sideKey = 'Lingual';
        else if (this.state.PerioMode === 1) sideKey = 'Facial';

        if (typeof this.props.data !== 'object') return 0;
        if (typeof this.props.data[sideKey] !== 'object') throw new Error();
        if (typeof this.props.data[sideKey][name] !== 'object') throw new Error();
        if (typeof this.props.data[sideKey][name][direction] !== 'number') throw new Error();
        return this.props.data[sideKey][name][direction];
    }

    getCellBG(colour) {
        if (colour === "#ffffff") {
            return "#f7f7f7";
        }
        return colour;
    }

    render() {

        if (!this.props.data) {
            return null;
        }

        let header = null;

        let leftSide = "Distal";
        let rightSide = "Mesial";
        if (this.props.tooth) {
            header = (
                <span id="sextant-buttons">
                    <h5>{this.buttonsFromTooth(this.props.tooth)}</h5>
                </span>
            );

            if ((this.props.tooth >= 9 && this.props.tooth <= 16) || (this.props.tooth >= 17 && this.props.tooth <= 24)) {
                leftSide = "Mesial";
                rightSide = "Distal";
            }
        }

        let weights = this.props.weights;
        let pd1Colour = getColourFromScore((this.getValue('PD', leftSide) / 9) * weights.pd_weight, 1, 8);
        let pd2Colour = getColourFromScore((this.getValue('PD', 'Center') / 9) * weights.pd_weight, 1, 8);
        let pd3Colour = getColourFromScore((this.getValue('PD', rightSide) / 9) * weights.pd_weight, 1, 8);

        let gm1Colour = getColourFromScore((this.getValue('GM', leftSide) / 9) * weights.gm_weight, 1, 8);
        let gm2Colour = getColourFromScore((this.getValue('GM', 'Center') / 9) * weights.gm_weight, 1, 8);
        let gm3Colour = getColourFromScore((this.getValue('GM', rightSide) / 9) * weights.gm_weight, 1, 8);

        let cal1Colour = getColourFromScore((this.getValue('CAL', leftSide) / 9) * weights.cal_weight, 1, 8);
        let cal2Colour = getColourFromScore((this.getValue('CAL', 'Center') / 9) * weights.cal_weight, 1, 8);
        let cal3Colour = getColourFromScore((this.getValue('CAL', rightSide) / 9) * weights.cal_weight, 1, 8);

        let bld1Colour = getColourFromScore(this.getValue('Bleeding', leftSide) * weights.bld_weight, 1, 8);
        let bld2Colour = getColourFromScore(this.getValue('Bleeding', 'Center') * weights.bld_weight, 1, 8);
        let bld3Colour = getColourFromScore(this.getValue('Bleeding', rightSide) * weights.bld_weight, 1, 8);

        let fg1Colour = getColourFromScore((this.getValue('FG', leftSide) / 4) * weights.fg_weight, 1, 8);
        let fg2Colour = getColourFromScore((this.getValue('FG', 'Center') / 4) * weights.fg_weight, 1, 8);
        let fg3Colour = getColourFromScore((this.getValue('FG', rightSide) / 4) * weights.fg_weight, 1, 8);

        let sup1Colour = getColourFromScore(this.getValue('Suppuration', leftSide) * weights.sup_weight, 1, 8);
        let sup2Colour = getColourFromScore(this.getValue('Suppuration', 'Center') * weights.sup_weight, 1, 8);
        let sup3Colour = getColourFromScore(this.getValue('Suppuration', rightSide) * weights.sup_weight, 1, 8);

        let mgj1Colour = getColourFromScore((this.getValue('MGJ', leftSide) / 9) * weights.mgj_weight, 1, 8);
        let mgj2Colour = getColourFromScore((this.getValue('MGJ', 'Center') / 9) * weights.mgj_weight, 1, 8);
        let mgj3Colour = getColourFromScore((this.getValue('MGJ', rightSide) / 9) * weights.mgj_weight, 1, 8);

        let mobColour = getColourFromScore((this.props.data.Mobility / 4) * weights.mob_weight, 1, 8);

        let plaColour = getColourFromScore((this.props.data.Plaque / 3) * weights.pla_weight, 1, 8);

        let blColour = getColourFromScore((this.props.data.BoneLoss / 3) * weights.bl_weight, 1, 8);

        return (
            <div id="summary-data">
                <span id="sextant-header">
                    <h4 id="sextant-title">Sextant {(this.props.position)} Tooth {this.props.tooth}</h4>
                    {header}
                </span>
                <Table className="perio-table" size="sm" bordered>
                    <thead>
                    <tr>
                        <th>Type</th>
                        <th>{leftSide} (L)</th>
                        <th>Center</th>
                        <th>{rightSide} (R)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th scope="row"><span href="#" id="tooltip-pd">PD</span></th>
                        <th style={{background: this.getCellBG(pd1Colour)}}>{this.getValue('PD', leftSide)}</th>
                        <th style={{background: this.getCellBG(pd2Colour)}}>{this.getValue('PD', 'Center')}</th>
                        <th style={{background: this.getCellBG(pd3Colour)}}>{this.getValue('PD', rightSide)}</th>
                    </tr>
                    <tr>
                        <th scope="row"><span href="#" id="tooltip-gm">GM</span></th>
                        <th style={{background: this.getCellBG(gm1Colour)}}>{this.getValue('GM', leftSide)}</th>
                        <th style={{background: this.getCellBG(gm2Colour)}}>{this.getValue('GM', 'Center')}</th>
                        <th style={{background: this.getCellBG(gm3Colour)}}>{this.getValue('GM', rightSide)}</th>
                    </tr>
                    <tr>
                        <th scope="row"><span href="#" id="tooltip-cal">CAL</span></th>
                        <th style={{background: this.getCellBG(cal1Colour)}}>{this.getValue('CAL', leftSide)}</th>
                        <th style={{background: this.getCellBG(cal2Colour)}}>{this.getValue('CAL', 'Center')}</th>
                        <th style={{background: this.getCellBG(cal3Colour)}}>{this.getValue('CAL', rightSide)}</th>
                    </tr>
                    <tr>
                        <th scope="row"><span href="#" id="tooltip-bld">Bld</span></th>
                        <th style={{background: this.getCellBG(bld1Colour)}}>{this.getValue('Bleeding', leftSide)}</th>
                        <th style={{background: this.getCellBG(bld2Colour)}}>{this.getValue('Bleeding', 'Center')}</th>
                        <th style={{background: this.getCellBG(bld3Colour)}}>{this.getValue('Bleeding', rightSide)}</th>
                    </tr>
                    <tr>
                        <th scope="row"><span href="#" id="tooltip-mgj">MGJ</span></th>
                        <th style={{background: this.getCellBG(mgj1Colour)}}>{this.getValue('MGJ', leftSide)}</th>
                        <th style={{background: this.getCellBG(mgj2Colour)}}>{this.getValue('MGJ', 'Center')}</th>
                        <th style={{background: this.getCellBG(mgj3Colour)}}>{this.getValue('MGJ', rightSide)}</th>
                    </tr>
                    <tr>
                        <th scope="row"><span href="#" id="tooltip-fg">FG</span></th>
                        <th style={{background: this.getCellBG(fg1Colour)}}>{this.getValue('FG', leftSide)}</th>
                        <th style={{background: this.getCellBG(fg2Colour)}}>{this.getValue('FG', 'Center')}</th>
                        <th style={{background: this.getCellBG(fg3Colour)}}>{this.getValue('FG', rightSide)}</th>
                    </tr>
                    <tr>
                        <th scope="row"><span href="#" id="tooltip-sup">Sup</span></th>
                        <th style={{background: this.getCellBG(sup1Colour)}}>{this.getValue('Suppuration', leftSide)}</th>
                        <th style={{background: this.getCellBG(sup2Colour)}}>{this.getValue('Suppuration', 'Center')}</th>
                        <th style={{background: this.getCellBG(sup3Colour)}}>{this.getValue('Suppuration', rightSide)}</th>
                    </tr>
                    <tr>
                        <th scope="row"><span href="#" id="tooltip-mobility">Mobility</span></th>
                        <th style={{background: this.getCellBG(mobColour)}} colSpan={3}>{this.props.data.Mobility}</th>
                    </tr>
                    <tr>
                        <th scope="row"><span href="#" id="tooltip-plaque">Plaque</span></th>
                        <th style={{background: this.getCellBG(plaColour)}} colSpan={3}>{this.props.data.Plaque}</th>
                    </tr>
                    <tr>
                        <th scope="row"><span href="#" id="tooltip-bl">Bone Loss</span></th>
                        <th style={{background: this.getCellBG(blColour)}} colSpan={3}>{this.props.data.BoneLoss}</th>
                    </tr>
                    </tbody>
                </Table>

                <UncontrolledTooltip target="tooltip-pd" placement="right">Probing Depth (ranges from 1 to 9)</UncontrolledTooltip>
                <UncontrolledTooltip target="tooltip-gm" placement="right">Gingival Margin (ranges from 1 to 9)</UncontrolledTooltip>
                <UncontrolledTooltip target="tooltip-cal" placement="right">Clinical Attachment Level (ranges from 1 to 9)</UncontrolledTooltip>
                <UncontrolledTooltip target="tooltip-bld" placement="right">Bleeding (0 for no bleeding, 1 for bleeding)</UncontrolledTooltip>
                <UncontrolledTooltip target="tooltip-mgj" placement="right">Mucco Gingival Junction (ranges from 1 to 9)</UncontrolledTooltip>
                <UncontrolledTooltip target="tooltip-fg" placement="right">Furcation Grade (ranges from 0 to 4)</UncontrolledTooltip>
                <UncontrolledTooltip target="tooltip-sup" placement="right">Suppuration (0 for no suppuration, 1 for suppuration)</UncontrolledTooltip>
                <UncontrolledTooltip target="tooltip-mobility" placement="right">Mobility (ranges from 0 to 4)</UncontrolledTooltip>
                <UncontrolledTooltip target="tooltip-plaque" placement="right">Plaque (ranges from 0 to 3)</UncontrolledTooltip>
                <UncontrolledTooltip target="tooltip-bl" placement="right">Bone loss (ranges from 0 to 3)</UncontrolledTooltip>
            </div>

        );

    }
}

export {
    SextantPerio
};
